import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { AccountFuneralCostListComponent } from './account-funeral-cost-list.component';
import { AccountFuneralCostModule } from '../account-funeral-cost/account-funeral-cost.module';

@NgModule({
  declarations: [AccountFuneralCostListComponent],
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    RippleModule,
    InputTextModule,
    DropdownModule,
    DynamicDialogModule,
    AccountFuneralCostModule,
  ],
  exports: [AccountFuneralCostListComponent],
})
export class AccountFuneralCostListModule {}
